import React, { createContext, useContext, useState, useEffect } from "react";
import { logoutSession } from "../authentications/logoutAuth";
import { sessionAuth } from "./sessionAuth";
import { pollGeneral } from "../DataApi/generalApis/pollGeneral";
import { closeSnackbar, enqueueSnackbar } from "notistack";
import { POLL_WAIT_TIME } from "../utilities/constants";
import { searchReadGeneral } from "../DataApi/generalApis/searchReadGeneral";
import { primaryColor, setPrimaryColor } from "../utilities/colors";
import { checkApi } from "../DataApi/onboarding/checkApi";
import { getAcquirers } from "../DataApi/miniStore/getAcquirers";
import { getAddress } from "../DataApi/miniStore/getAddress";

const SessionContext = createContext();

export const SessionProvider = ({ children }) => {
  const [themeChanged, setThemeChanged] = useState(0);

  const [searchQuery, setSearchQuery] = useState("");
  const [isLoadingApps, setIsLoadingApps] = useState(true);
  const [oddAppsInfo, setOddAppsInfo] = useState([]);
  const [billingAddress, setBillingAddress] = useState({});
  const [shippingAddresses, setShippingAddresses] = useState([]);
  const [publicPartnerId, setPublicPartnerId] = useState(null);
  const [sessionInfo, setSessionInfo] = useState(() => {
    const storedSessionInfo = JSON.parse(localStorage.getItem("sessionInfo"));
    return (
      storedSessionInfo || {
        company_id: null,
        user_id: null,
        context: null,
        name: null,
        username: null,
        user_companies: null,
        is_subscribed: null,
        is_admin: false,
        is_merchant: false,
        is_vtex_admin: false,
        is_vtex_omantal: false,
        isVTEX: false,
        VtexAdmin: false,
        ionAdmin: false,
      }
    );
  });
  const [authenticated, setAuthenticated] = useState(null);
  const [selectedView, setSelectedView] = useState(() => {
    const viewType = localStorage.getItem("selectedView") || "kanbanView";
    localStorage.setItem("selectedView", viewType);
    return viewType;
  });

  const changeview = (view) => {
    setSelectedView(view);
  };
  const setSessInfo = (
    company_id,
    user_id,
    context,
    name,
    username,
    user_companies,
    is_suspended,
    company_partner_id,
    is_admin,
    is_merchant,
    is_vtex_admin,
    is_vtex_omantal,
    VtexAdmin,
    ionAdmin,
    isVTEX = sessionInfo.isVTEX
  ) => {
    setSessionInfo({
      ...sessionInfo, // Spread the existing properties
      company_id,
      user_id,
      context,
      name,
      username,
      user_companies,
      is_suspended: window.location.host === "localhost" ? false : is_suspended,
      company_partner_id,
      is_admin,
      is_merchant,
      is_vtex_admin,
      is_vtex_omantal,
      VtexAdmin,
      ionAdmin,
      VtexAdmin,
      ionAdmin,
      isVTEX,
    });
  };
  useEffect(() => {
    localStorage.setItem("sessionInfo", JSON.stringify(sessionInfo));
  }, [sessionInfo]);

  useEffect(() => {
    localStorage.setItem("selectedView", selectedView);
  }, [selectedView]);

  const handleAuthentication = (status) => {
    setAuthenticated(status);
    localStorage.setItem("authenticated", status.toString());
  };
  const handleLogout = async () => {
    try {
      handleAuthentication(false);
      await logoutSession();
    } catch (error) {
      handleAuthentication(false);

      console.error("An error occurred:", error);
    }
  };

  const handleTheme = () => {
    setPrimaryColor({
      ...primaryColor,
      primary: "#FF641B",
      secandary: "#9C9A9A",
    });
  };
  const handleCheckVTEX = async () => {
    try {
      const response = await checkApi({
        params: { domain: window.location.origin },
        endpoint: "/vtex/vtex_info",
      });
      if (response?.result) {
        if (response?.result?.vtex) {
          handleTheme();
        }
        return response.result;
      }
      return false;
    } catch (error) {
      return false;
    }
  };
  const handleGetAddress = async ({ partner_id } = {}) => {
    try {
      let addressResponse = await getAddress({ partner_id });

      if (addressResponse?.result) {
        const { partner, delivery } = addressResponse.result;
        setBillingAddress(partner);
        setShippingAddresses(delivery?.length ? delivery : [partner]);
      }
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const handleCheckSession = async () => {
    const [sessionResponse, VTEXResponse] = await Promise.all([
      sessionAuth(),
      // handleCheckVTEX(),
    ]);
    // console.log("sessionResponse?.result", sessionResponse, VTEXResponse);
    const VtexAdmin = sessionResponse?.result?.VtexAdmin || false;
    const ionAdmin = sessionResponse?.result?.ionAdmin || false;
    const isVTEX = false;
    // console.log("VtexAdmin,ionAdmin,isVTEX", VtexAdmin, ionAdmin, isVTEX);
    if (sessionResponse?.result) {
      handleGetAddress();

      const {
        user_context,
        uid,
        company_id,
        name,
        username,
        user_companies,
        suspended_merchant,
        company_partner_id,
        is_admin,
        is_merchant,
        is_vtex_admin,
        is_vtex_omantal,
      } = sessionResponse.result;
      // console.log("Session Response:", sessionResponse);
      // console.log("VTEXResponse", VTEXResponse);
      setSessInfo(
        company_id,
        uid,
        user_context,
        name,
        username,
        user_companies,
        suspended_merchant,
        company_partner_id,
        is_admin,
        is_merchant,
        is_vtex_admin,
        is_vtex_omantal,
        VtexAdmin,
        ionAdmin,
        isVTEX
      );
      handleAuthentication(true);
    } else {
      setSessInfo(
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      );
      handleAuthentication(false);
    }

    // if (VTEXResponse) {
    //   handleTheme();
    // }
    setThemeChanged(themeChanged + 1);
  };
  const handlelongPolling = async (openedSnackbarId, timeout) => {
    clearTimeout(timeout);
    const timeoutId = setTimeout(() => {
      if (openedSnackbarId) {
        closeSnackbar();
        enqueueSnackbar("Connection restored. You are back online.", {
          variant: "info",
        });
      }
    }, POLL_WAIT_TIME * 1.5);
    const response = await pollGeneral();

    if (typeof response.result !== "undefined") {
      handlelongPolling();
    } else {
      console.log("Not Connected to server");
      const snackbarId = enqueueSnackbar(
        "Connection lost. Trying to reconnect...",
        {
          variant: "warning",
          persist: false,
          preventDuplicate: true,
        }
      );
      setTimeout(() => {
        handlelongPolling(snackbarId, timeoutId);
      }, POLL_WAIT_TIME);
    }
  };

  const handleGetAppsDetails = async () => {
    const { context, company_id } = sessionInfo;

    if (authenticated) {
      let response = await searchReadGeneral({
        company_id,
        context,
        domain: [
          "&",
          "!",
          ["name", "=like", "theme_%"],
          ["application", "=", true],
        ],
        fields: [
          "icon",
          "to_buy",
          "name",
          "state",
          "summary",
          "website",
          "application",
          "shortdesc",
        ],
        model: "ir.module.module",
        endpoint: "/web/dataset/search_read",
        pagination: { limit: 100 },
      });
      if (response?.result?.records?.length > 0) {
        setOddAppsInfo(response?.result?.records);
      }
    }
  };

  // useEffect(() => {
  //   handleGetAppsDetails();
  // }, [authenticated]);

  return (
    <SessionContext.Provider
      value={{
        setSessInfo,
        billingAddress,
        shippingAddresses,
        publicPartnerId,
        setPublicPartnerId,
        handleGetAddress,
        sessionInfo,
        authenticated,
        handleAuthentication,
        changeview,
        selectedView,
        searchQuery,
        setSearchQuery,
        handleLogout,
        handleCheckSession,
        isLoadingApps,
        setIsLoadingApps,
        oddAppsInfo,
        setOddAppsInfo,
        themeChanged,
        setThemeChanged,
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => useContext(SessionContext);
